import type { SVGProps } from "react";
export const NotFoundIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		aria-hidden="true"
		style={{
			clipRule: "evenodd",
			fillRule: "evenodd",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
		}}
		viewBox="0 0 647 340"
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
	>
		<title>404 text in front of the main building of tum</title>
		<path
			d="M10 337.6S-49 130 125.8 30.9s233 72.7 347.6 64.8C588 88 617 128.8 636 183.4c28.3 81.6-12.3 155-12.3 155l-613.8-.8Z"
			style={{
				fill: "#f3f9ff",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M586.7 98.4c-1.7 0-3.2.4-4.7 1a7 7 0 0 0 .3-2 8.5 8.5 0 0 0-16.6-2.4 19.2 19.2 0 1 0-38 4.5 13.2 13.2 0 0 0-23.3 8.5c0 7.3 6 13.2 13.2 13.2h69a11.4 11.4 0 1 0 0-22.8M82.3 87.5c-1.7 0-3.2.3-4.7 1A8.5 8.5 0 0 0 61.3 84a19.2 19.2 0 1 0-38 4.4A13.2 13.2 0 0 0 0 97.1c0 7.3 6 13.2 13.2 13.2h69.1a11.4 11.4 0 1 0 0-22.8M437 39c-1.3 0-2.5.3-3.7.8a6.8 6.8 0 0 0-6.6-8.4c-3 0-5.6 2-6.5 4.9a15.4 15.4 0 1 0-30.4 3.6 10.6 10.6 0 0 0-18.6 6.8c0 5.9 4.7 10.6 10.5 10.6h55.4a9.2 9.2 0 1 0 0-18.3"
			style={{
				fill: "#e1f1ff",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M566.2 211.3 545 281a27 27 0 1 0 51.7 0l-21.1-69.7a5 5 0 0 0-9.4 0"
			style={{
				fill: "#9abce4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M570.9 337.6V235"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#7ca5d1",
				strokeWidth: 2,
			}}
		/>
		<path
			d="m613.5 248.2-15 49.4a19.1 19.1 0 1 0 36.6 0l-15-49.4a3.5 3.5 0 0 0-6.6 0"
			style={{
				fill: "#9abce4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M616.8 337.6V265"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#7ca5d1",
				strokeWidth: "1.42px",
			}}
		/>
		<path
			d="M111.3 316.9h-.5a14.2 14.2 0 0 0-26.2 1.4c-.8-.2-1.7-.2-2.5-.2a14.2 14.2 0 0 0-14.2 14.5h57.5l.1-1.5c0-7.9-6.3-14.2-14.2-14.2"
			style={{
				fill: "#9abce4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M79.8 322.6h-.6A14.2 14.2 0 0 0 53 324l-2.5-.2c-7.8 0-14.2 6.3-14.2 14.2v.4H94v-1.6c0-7.8-6.3-14.2-14.1-14.2"
			style={{
				fill: "#c2d7ef",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M24.6 211.3 3.4 281a27 27 0 1 0 51.7 0L34 211.3a5 5 0 0 0-9.4 0"
			style={{
				fill: "#9abce4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M29.3 337.6V235"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#7ca5d1",
				strokeWidth: 2,
			}}
		/>
		<path
			d="M89.5 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M91.1 161H102v3.5H91.1zm0 18.9H102v3.5H91.1zm0-13.6H102v12.1H91.1z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M526.5 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M528.1 161H539v3.5h-10.9zm0 18.9H539v3.5h-10.9zm0-13.6H539v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M85.5 146.6h459.7v3.3H85.5z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M531.5 159.3v26h12v9.4H87.3v-9.3h11.6v-26.1H87.3V150h456.2v9.3h-12Z"
			style={{
				fill: "#c2d7ef",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M105.7 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M107.3 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M127 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M128.6 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M148.2 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M149.8 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M169.4 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M171 161h10.9v3.5H171zm0 18.9h10.9v3.5H171zm0-13.6h10.9v12.1H171z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M190.6 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M192.2 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M211.8 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M213.4 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M233 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M234.6 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M254.2 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M255.8 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M275.4 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M277 161h10.9v3.5H277zm0 18.9h10.9v3.5H277zm0-13.6h10.9v12.1H277z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M296.7 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M298.3 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M317.9 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M319.5 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M339.1 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M340.7 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M360.3 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M361.9 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M381.5 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M383.1 161H394v3.5h-10.9zm0 18.9H394v3.5h-10.9zm0-13.6H394v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M402.7 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M404.3 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M423.9 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M425.5 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M445.1 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M446.7 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M466.4 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M468 161h10.9v3.5H468zm0 18.9h10.9v3.5H468zm0-13.6h10.9v12.1H468z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M487.6 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M489.2 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M508.8 159.3h14v26.1h-14z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M510.4 161h10.9v3.5h-10.9zm0 18.9h10.9v3.5h-10.9zm0-13.6h10.9v12.1h-10.9zM93.5 194.7h443.2v20.7H93.5z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M101.7 194.7h427.2v20.7H101.7z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M104.7 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M106.5 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M98.6 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M98.6 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M119.7 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M119.7 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M125.9 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M127.8 198.6H141v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M140.9 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M140.9 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M147.1 196.5H164v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M149 198.6h13.2v14.7H149z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M162.1 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M162.1 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M168.3 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M170.2 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M183.4 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M183.4 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M189.5 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M191.4 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M204.6 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M204.6 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M210.7 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M212.6 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M225.8 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M225.8 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M232 196.5h16.9v18.9H232z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M233.8 198.6H247v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M247 194.7h3.1v13.9H247z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M247 208.5h3.1v6.9H247z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M253.2 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M255 198.6h13.2v14.7H255z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M268.2 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M268.2 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M274.4 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M276.2 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M289.4 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M289.4 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M295.6 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M297.5 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M507.4 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M509.3 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M527.3 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M527.3 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M506.2 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M506.2 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M486.2 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M488.1 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M485 194.7h3.1v13.9H485z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M485 208.5h3.1v6.9H485z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M465 196.5h16.9v18.9H465z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M466.9 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M463.8 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M463.8 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M443.8 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M445.7 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M442.6 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M442.6 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M422.6 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M424.5 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M421.4 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M421.4 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M401.4 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M403.2 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M400.1 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M400.1 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M380.2 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M382 198.6h13.2v14.7H382z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M378.9 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M378.9 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M359 196.5h16.9v18.9H359z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M360.8 198.6H374v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M357.7 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M357.7 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M337.7 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M339.6 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M336.5 194.7h3.1v13.9h-3.1z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M336.5 208.5h3.1v6.9h-3.1z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M316.5 196.5h16.9v18.9h-16.9z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M318.4 198.6h13.2v14.7h-13.2z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M312.5 194.7h4v13.9h-4z"
			style={{
				fill: "#c2d7ef",
			}}
		/>
		<path
			d="M312.5 208.5h4v6.9h-4z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M93.5 215.4h443.2v113H93.5z"
			style={{
				fill: "#e3eefa",
			}}
		/>
		<path
			d="M93.5 328.4h443.2v9.9H93.5z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M261.3 296.1h29.6v42.3h-29.6zm38.7 0h29.6v42.3H300zm38.7 0h29.6v42.3h-29.6z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M232.4 301h164.3v4.6H232.4z"
			style={{
				fill: "#adccea",
			}}
		/>
		<path
			d="M250 281.3h-2.4v7.7h-.8v-7.7h-2.4v-.7h5.6v.7Zm5.7 7.7h-4.2v-8.4h4v.7h-3.3v3.1h3v.7h-3v3.2h3.5v.7Zm7.6-.4a5.5 5.5 0 0 1-2.3.5 4 4 0 0 1-2.9-1.1c-.7-.8-1-1.8-1-3 0-1.4.3-2.5 1.1-3.3a4 4 0 0 1 3-1.3 5.3 5.3 0 0 1 2 .5l-.2.6a4.3 4.3 0 0 0-1.8-.4c-1 0-1.8.4-2.4 1-.7.7-1 1.6-1 2.8 0 1 .3 2 1 2.6a3 3 0 0 0 2.2 1 4.5 4.5 0 0 0 2-.5l.3.6Zm7.7.4h-.7v-4h-4.6v4h-.7v-8.4h.7v3.8h4.6v-3.8h.8v8.4Zm9 0h-.7l-4.8-6.8a3.7 3.7 0 0 1-.3-.5v7.3h-.7v-8.4h.8l4.6 6.7a8 8 0 0 1 .4.5 9 9 0 0 1 0-1v-6.2h.7v8.4Zm2.5-8.4h.7v8.4h-.7zm2.5 7.7.4-.5 1 .5 1.2.2c.5 0 1-.2 1.3-.5.4-.3.5-.7.5-1.2 0-.4-.1-.8-.4-1-.3-.3-.7-.6-1.3-.8-.8-.2-1.4-.6-1.8-1-.3-.3-.5-.7-.5-1.3 0-.7.2-1.2.7-1.6.4-.5 1-.7 1.8-.7a3.8 3.8 0 0 1 2 .6l-.3.6-.8-.4h-1c-.5 0-.9 0-1.2.3-.3.3-.5.6-.5 1.1 0 .4.2.7.5 1 .2.3.7.5 1.4.7.8.3 1.3.6 1.7 1 .3.4.5.8.5 1.4 0 .7-.2 1.3-.7 1.8a3 3 0 0 1-2 .6c-.4 0-.9 0-1.3-.2a4 4 0 0 1-1.2-.6Zm12.8.3a5.4 5.4 0 0 1-2.3.5 4 4 0 0 1-2.9-1.1c-.7-.8-1-1.8-1-3 0-1.4.3-2.5 1.1-3.3a4 4 0 0 1 3-1.3 5.3 5.3 0 0 1 2 .5l-.2.6a4.3 4.3 0 0 0-1.8-.4c-1 0-1.8.4-2.4 1-.7.7-1 1.6-1 2.8 0 1 .3 2 1 2.6a3 3 0 0 0 2.2 1 4.5 4.5 0 0 0 2-.5l.3.6Zm7.8.4h-.8v-4h-4.6v4h-.8v-8.4h.8v3.8h4.6v-3.8h.8v8.4Zm6.6 0H308v-8.4h4v.7h-3.3v3.1h3v.7h-3v3.2h3.5v.7Zm11-3.3c0 1.2-.2 2-.7 2.6-.6.6-1.3.8-2.3.8-1 0-1.7-.2-2.2-.8-.5-.5-.8-1.4-.8-2.4v-5.3h.8v5.2c0 .9.2 1.5.6 2 .3.4 1 .7 1.7.7s1.2-.3 1.6-.7c.4-.4.6-1 .6-2v-5.2h.7v5.1Zm8.8 3.3h-.6l-4.8-6.8a3.7 3.7 0 0 1-.3-.5v7.3h-.7v-8.4h.8l4.6 6.7a9.7 9.7 0 0 1 .4.5 12.9 12.9 0 0 1 0-1v-6.2h.7v8.4Zm2.5-8.4h.7v8.4h-.7zm9.3 0-3.2 8.4h-.7l-3-8.4h.8l2.4 6.7a3.5 3.5 0 0 1 .2.8v-.4l.2-.4 2.5-6.7h.8Zm5.6 8.4h-4.2v-8.4h4v.7H346v3.1h3.1v.7h-3v3.2h3.5v.7Zm7.3 0h-.9l-1.2-2.4-.7-1c-.3-.2-.5-.2-.9-.2h-1v3.6h-.7v-8.4h2.3c.7 0 1.3.2 1.8.6.5.4.7.9.7 1.6 0 .6-.2 1.1-.5 1.5-.3.4-.8.7-1.4.8l.5.4.5.8 1.5 2.7Zm-4.7-7.7v3.4h1.4c.6 0 1-.2 1.4-.5.3-.3.5-.8.5-1.3s-.1-1-.5-1.2c-.3-.3-.7-.4-1.3-.4H352Zm5.8 7 .4-.5 1 .5 1.2.2c.5 0 1-.2 1.3-.5.4-.3.5-.7.5-1.2 0-.4-.1-.8-.4-1-.3-.3-.7-.6-1.3-.8-.8-.2-1.4-.6-1.8-1-.3-.3-.5-.7-.5-1.3 0-.7.2-1.2.7-1.6.4-.5 1-.7 1.8-.7a3.8 3.8 0 0 1 2 .6l-.3.6-.8-.4h-1c-.5 0-.9 0-1.2.3-.3.3-.5.6-.5 1.1 0 .4.2.7.4 1 .3.3.8.5 1.5.7.8.3 1.3.6 1.7 1 .3.4.5.8.5 1.4 0 .7-.3 1.3-.7 1.8a3 3 0 0 1-2 .6c-.4 0-.9 0-1.3-.2a4 4 0 0 1-1.2-.6Zm7-7.7h.7v8.4h-.7zm8 .7h-2.4v7.7h-.8v-7.7h-2.4v-.7h5.6v.7Zm-.2 7.7 3.2-8.4h.8l3.2 8.4h-.9l-.9-2.5h-3.6l-1 2.5h-.8Zm2-3.2h3.2l-1.4-3.8-.1-.2-.1-.4a5.3 5.3 0 0 1-.2.6l-1.4 3.8Zm10.5-4.5h-2.4v7.7h-.7v-7.7h-2.4v-.7h5.6v.7Z"
			style={{
				fill: "#7ca5d1",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M137.4 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M139.6 237.5H155v4.9h-15.4zm0 26.7H155v4.9h-15.4zm0-19.2H155v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M179.7 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M181.9 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M221.9 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M224.2 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M264.2 235H284v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M266.5 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M306.5 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M308.7 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M348.7 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M351 237.5h15.4v4.9H351zm0 26.7h15.4v4.9H351zm0-19.2h15.4v17.1H351z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M391 235h19.8v36.9H391z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M393.3 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M433.3 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M435.5 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M475.5 235h19.8v36.9h-19.8z"
			style={{
				fill: "#7ca5d1",
			}}
		/>
		<path
			d="M477.8 237.5h15.4v4.9h-15.4zm0 26.7h15.4v4.9h-15.4zm0-19.2h15.4v17.1h-15.4z"
			style={{
				fill: "#9abce4",
			}}
		/>
		<path
			d="M230.9 275.2h164.6v16.5H230.9z"
			style={{
				fill: "#e3eefa",
			}}
		/>
		<path
			d="M156.9 83.7c.4 4.1 1.5 7 3.2 8.6a7.8 7.8 0 0 0 6.5 2 7.8 7.8 0 0 0 6-3.2c1.3-2 1.7-5.2 1.2-9.7-.4-3.8-1.4-6.6-3.2-8.2a8 8 0 0 0-6.5-2 7.7 7.7 0 0 0-5.8 3.4c-1.4 2-1.9 5-1.4 9.1M144.3 85a21 21 0 0 1 4-16.1 21 21 0 0 1 14.8-7.2c6.8-.7 12.2.6 16.2 3.8 4 3.3 6.4 8.2 7 14.7.6 4.8.2 8.8-1 12a17.2 17.2 0 0 1-6.3 7.8 23 23 0 0 1-11 3.7c-4.6.5-8.5.1-11.6-1a17.2 17.2 0 0 1-8-6.2c-2.2-3-3.6-6.8-4-11.5m58.6-.5c.2 2.6 1 4.5 2.2 5.7a5 5 0 0 0 4.2 1.4 5 5 0 0 0 3.8-2.2c.9-1.4 1.2-3.4 1-6.2-.4-2.5-1-4.4-2.3-5.5a5 5 0 0 0-4-1.5c-1.7.2-3 1-4 2.4-.9 1.4-1.2 3.3-1 6m-11.3 1.1a15 15 0 0 1 3.4-11.5 17 17 0 0 1 11.8-5.7c6-.6 10.6.6 14 3.7a15 15 0 0 1 4.6 9.8c.5 4.6-.6 8.4-3.3 11.6a17.6 17.6 0 0 1-12 5.7c-4.7.5-8.7-.3-11.9-2.4a14.5 14.5 0 0 1-6.6-11.2m50.7-5.3c.2 2.4.9 4 2 5a5 5 0 0 0 3.9 1.4 4 4 0 0 0 3-2c.9-1.2 1.1-3 .8-5.6-.2-2.4-.9-4.1-1.9-5.1-1-1-2.2-1.5-3.6-1.4a5 5 0 0 0-3.4 2.1c-.8 1.2-1.1 3.1-.8 5.6m-8.7 27-4.2-40.6 10.6-1 .4 4.3a16 16 0 0 1 3.6-4.2c1.6-1 3.4-1.6 5.4-1.8 3.9-.5 7.1.7 9.6 3.5 2.4 2.8 3.9 6.4 4.4 10.9.5 4.9-.3 8.7-2.4 11.5a11 11 0 0 1-8.5 4.8 11.4 11.4 0 0 1-9-2.6l1.5 14-11.4 1.3Zm33.8-23.1 11.1-2.2a5.6 5.6 0 0 0 2.3 2.7c.8.4 2 .6 3.4.5 1.5-.2 2.6-.6 3.4-1.4.6-.5.8-1.1.8-1.9-.1-.8-.6-1.4-1.5-1.7-.6-.3-2.3-.5-5-.7a51 51 0 0 1-8.3-1c-1.6-.4-3-1.3-4.2-2.6a7.7 7.7 0 0 1-2-4.5c-.3-2 .1-3.7 1.1-5.2s2.4-2.7 4.3-3.6a33 33 0 0 1 15.7-2c1.8.4 3.3 1.1 4.5 2.1 1.2 1 2.3 2.5 3.3 4.3l-10.6 2.2c-.4-1-1-1.6-1.6-2a7 7 0 0 0-3.3-.5c-1.3.1-2.2.5-2.8 1a2 2 0 0 0-.7 1.7c.1.7.5 1.2 1.3 1.5.8.3 2.4.5 5 .5 3.7 0 6.6.3 8.5 1 2 .5 3.4 1.4 4.5 2.7a8 8 0 0 1 2 4.5 9.4 9.4 0 0 1-5.5 9.4c-2.1 1.2-5 2-8.9 2.4-5.3.6-9.3.2-11.7-1a10.4 10.4 0 0 1-5-6.2m37-1.3 11.2 1.3-1.1 10-11.2-1.3 1-10Zm3-30.6 12.1 1.3-1 9.3-4.5 18.3-7.4-.9-.2-18.8 1-9.2Z"
			style={{
				fill: "#0065bd",
				fillRule: "nonzero",
			}}
		/>
		<clipPath id="a">
			<path clipRule="nonzero" d="M45.1 143h522.1v195.3H45.1z" />
		</clipPath>
		<g clipPath="url(#a)">
			<path
				d="m135 270.4-3.6.3 3-7.5.6 7.2Zm76.8 53-4-47.8-10.5-10.4-9 .7-1.3-16.7-10.5-10.4-33.4 2.8 27-67.2-10.4-10.5-47.8 4-49.2 117.3 3.3 39.2 10.4 10.4 62.2-5.2 1.7 20 10.5 10.5 45.2-3.8-2.6-31.4 18.3-1.5Z"
				style={{
					fill: "#0065bd",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="m135 270.4-3.6.3 3-7.5.6 7.2Zm76.8 53-4-47.8-10.5-10.4-9 .7-1.3-16.7-10.5-10.4-33.4 2.8 27-67.2-10.4-10.5-47.8 4-49.2 117.3 3.3 39.2 10.4 10.4 62.2-5.2 1.7 20 10.5 10.5 45.2-3.8-2.6-31.4 18.3-1.5Z"
				opacity={0.6}
				style={{
					fill: "#0a2d57",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="m201.3 313.2-18.4 1.6 2.7 31.3-45.3 3.8-2.6-31.3-71.7 6-3.3-39.1 49.2-117.2 47.8-4-43.4 108 18.7-1.6-2.3-28 43.8-3.6L179 267l18.4-1.6 4 47.8ZM324 294c-2.2 35.3-10.8 45.8-21.5 45.1-8.7-.5-15.2-8.2-16.1-29.9l.2-5.3c2.2-35.3 10.8-45.8 21.6-45.2 8.7.6 15.1 8.2 16 30 0 1.7 0 3.4-.2 5.3m-12.8-97c-43.2-2.6-76.2 30.5-80 91.2-.3 5.7-.4 11.3-.1 16.6-2.1 58 26.2 93.3 68.4 95.9 43.2 2.6 76.2-30.6 79.9-91.2.3-5.8.4-11.3.2-16.6 2-58-26.2-93.3-68.4-95.9"
				style={{
					fill: "#0065bd",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="M324 294c-2.2 35.3-10.8 45.8-21.5 45.1-8.7-.5-15.2-8.2-16.1-29.9l.2-5.3c2.2-35.3 10.8-45.8 21.6-45.2 8.7.6 15.1 8.2 16 30 0 1.7 0 3.4-.2 5.3m-12.8-97c-43.2-2.6-76.2 30.5-80 91.2-.3 5.7-.4 11.3-.1 16.6-2.1 58 26.2 93.3 68.4 95.9 43.2 2.6 76.2-30.6 79.9-91.2.3-5.8.4-11.3.2-16.6 2-58-26.2-93.3-68.4-95.9"
				opacity={0.6}
				style={{
					fill: "#0a2d57",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="M324 294.3c2.2-35.3-5.1-46.8-15.8-47.5-10.8-.6-19.4 9.9-21.6 45.2-2.1 35.3 5.1 46.8 15.9 47.4 10.7.7 19.3-9.8 21.5-45.1m-92.7-5.7c3.7-60.7 36.7-93.9 79.9-91.2 43.2 2.6 71.9 39.6 68.2 100.3-3.7 60.6-36.7 93.8-80 91.2-43.2-2.7-71.9-39.6-68.1-100.3m249.5-16.2-5.6-.4 6.5-9.7-.9 10.1Zm84 6.7-20.3-1.6 2.2-28-48.5-3.8-9.3 5.7 52.3-78.5-53-4.3-15.6 5.3L398.8 281l-3.1 39.2 79.3 6.3-2.5 31.4 50 4 15.7-5.3 2-24.9 5.2.4L561 327l3.8-47.8Z"
				style={{
					fill: "#0065bd",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="m480.8 272.4-5.6-.4 6.5-9.7-.9 10.1Zm84 6.7-20.3-1.6 2.2-28-48.5-3.8-9.3 5.7 52.3-78.5-53-4.3-15.6 5.3L398.8 281l-3.1 39.2 79.3 6.3-2.5 31.4 50 4 15.7-5.3 2-24.9 5.2.4L561 327l3.8-47.8Z"
				opacity={0.6}
				style={{
					fill: "#0a2d57",
					fillRule: "nonzero",
				}}
			/>
			<path
				d="m561 326.9-20.3-1.6-2.5 31.3-50-4 2.5-31.3-79.4-6.3 3.1-39.2 73.9-107.2 52.9 4.3-66 99 20.8 1.7 2.2-28 48.5 4-2.2 27.9 20.3 1.6-3.8 47.8Z"
				style={{
					fill: "#0065bd",
					fillRule: "nonzero",
				}}
			/>
		</g>
		<path
			d="M600 251.6c-.3.1-.6 0-.8-.2l-.8-1.3a.5.5 0 1 1 .9-.6l.8 1.3c.2.3.1.6-.1.8m3.3 12.2-.2.1c-1.3.9-3.1.5-4-.9l-4-6.5 5-3.1 4 6.4c1 1.4.5 3.2-.8 4"
			style={{
				fill: "#5e9dcc",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m599.5 256.4-.2.1c-1.4.9-3.1.5-4-.9l-3.2-5.1c-.5-.7-.3-1.7.5-2.2l1.2-.8a3 3 0 0 1 4 1l2.6 4a3 3 0 0 1-1 4"
			style={{
				fill: "#3070b3",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m583.5 248.1 4.3 6 3-3.6-5-3.9-2.3 1.5Z"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m586.5 246.4-.6 5.2-2.5-3.6 3.1-1.6Z"
			style={{
				fill: "#4470b2",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M588.3 243.7a4.6 4.6 0 1 1-8.7 3.1 4.6 4.6 0 0 1 8.7-3"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<clipPath id="b">
			<path
				clipRule="nonzero"
				d="M582.4 241a4.6 4.6 0 1 0 3 8.6 4.6 4.6 0 0 0-3-8.6Z"
			/>
		</clipPath>
		<g clipPath="url(#b)">
			<path
				d="M579.9 242.3s.6 2.1 4.3 3.2l.8.4s2 3.3 5.1 2c0 0 1.2-4-3.6-7-3.4-2-6.6 1.4-6.6 1.4"
				style={{
					fill: "#0a2d57",
					fillRule: "nonzero",
				}}
			/>
		</g>
		<path
			d="m579.8 247.2-.2 1.1c0 .1.1.3.3.2l.7-.2-.8-1Zm6.9-1.9a1.5 1.5 0 1 1-3-.2 1.5 1.5 0 0 1 3 .2"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M584.7 245.7s-.1-1 .9-1.1"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#4470b2",
				strokeWidth: ".18px",
			}}
		/>
		<path
			d="M592.5 240.7a3.1 3.1 0 1 1-6.3.1 3.1 3.1 0 0 1 6.3-.1m-11.9 5.6a.3.3 0 1 1-.5.1.3.3 0 0 1 .5-.2"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M579.8 245.4s.4-.4 1-.1"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#0a2d57",
				strokeWidth: ".24px",
			}}
		/>
		<path
			d="M581.4 248.6s0-.4.4-.4"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#4470b2",
				strokeWidth: ".18px",
			}}
		/>
		<path
			d="m609.5 321 3.7 2.6 2.2-4-3.8-2.8-2.1 4.1Z"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m612 323.9 3.5-5 5.3 3.6-6.7 9.4c-.3.5-1 .2-1-.3l.9-6.3-2-1.4Z"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m598 274.6-9.8 1.7s-8.4 26.2 20.4 46.6c0 0 3.1-2.3 5.7-7 0 0-22.1-13.2-16.3-41.3"
			style={{
				fill: "#0c3966",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M576 327.1v4.6h4.6v-4.8l-4.7.2Z"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M575 331.2h6.1l.1 6.4h-11.5c-.5 0-.7-.7-.2-1l5.5-3v-2.4Z"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m587.8 268.4.4 2s-13.6 19.5-14.3 58c0 0 4.7 1 8.8 0 0 0-.5-32.5 13-47.3 0 0 6.3-5.3 2.7-14l-10.6 1.3Z"
			style={{
				fill: "#114584",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m588.3 270.4 10.8-1"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#184a7c",
				strokeWidth: ".24px",
			}}
		/>
		<path
			d="M581.6 270.2c-4.6 0-10-3.4-14.4-7.5-1.3-1.3-.6-2 .7-3.2a3.2 3.2 0 0 1 4.6-.1c3.3 3.2 6.7 4.6 9.9 4.2 6-.7 10.1-7.4 10.2-7.4a3.2 3.2 0 0 1 5.5 3.4c-.2.4-5.8 9.3-14.9 10.4l-1.6.2"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<clipPath id="c">
			<path
				clipRule="nonzero"
				d="M592.6 256.2s-4.3 6.7-10.2 7.4c-3.2.4-6.6-1-10-4.2a3.2 3.2 0 0 0-4.5 0c-1.3 1.4-2 2-.7 3.3 4.4 4.1 9.8 7.6 14.4 7.5.6 0 1.1 0 1.6-.2 9-1.1 14.7-10 14.9-10.4a3.2 3.2 0 0 0-5.5-3.4Z"
			/>
		</clipPath>
		<g clipPath="url(#c)">
			<path
				d="m586.6 260.8-.2 10.6 8-2.7-4.7-9.5-3.1 1.6Z"
				style={{
					fill: "#4470b2",
					fillRule: "nonzero",
				}}
			/>
		</g>
		<path
			d="m572.6 260.6-.1-1 .4.2-1.4-2.9-.5-.6c-.5-.3-1-.2-1.3-.2-.6 0-.4.1-.4.7-.6 0-1.9.3-2.6-2.5-.1-.5-.7-.9-1.3-.8-1 .3.6-.1.6.3a.9.9 0 0 0-1.5.7.9.9 0 0 0-1.1.8v.3c-.4.2-.4.3-.4.7v.3c.2.8.4 1 .7 1.7l.4.8c1 1.4 3.2 4.2 5.7 4.8 3.4.9 2.8-3.3 2.8-3.3"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M561.6 252.3v.5c0 .2 0 .3.2.4l6.4 7.7c.2.2.5.5.8.5h2.8c.3 0 .6-.4.8-.7l-8.5-8.1-2.5-.3Z"
			style={{
				fill: "#03081d",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m561.7 252.5 7 8.2c.1.2.3.2.5.2h3c.3 0 .4-.3.3-.4l-7-8.2a1 1 0 0 0-.8-.3H562c-.3 0-.4.3-.2.5"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m562.9 252.8 6.3 7.4.4.2h1.8c.2 0 .3-.3.2-.4l-6.2-7.3a.9.9 0 0 0-.7-.3H563c-.1 0-.2.2-.1.4"
			style={{
				fill: "#f7f4ed",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m570.4 256.1-1.5-.2a.8.8 0 0 0-.5 1.6l2.7 1.3-.4-1.8-.3-.9Z"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M586.7 254.4s-1-1.2.8-3.3c2.2-2.4 3.4-1.6 4.4-1.1l-5.2 4.4Z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M598.4 267.2s-3-4.2-2.5-7.4c.3-3.2 1.1-8.9-3.4-10.3 0 0-2 0-3.7 1.7-1.4 1.3-5 4.9-3 8.7.1.5.4.9.6 1.2.2 2 .7 4.8 1.4 7.6l10.6-1.5Z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m593.3 259.3 2.6 8.2 4-.5-7.5-11.8.9 4.1Z"
			style={{
				fill: "#e3eefa",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M593.7 249s-4.5 1.8-4.6 6.5c-.1 4.8 3.5 8.6 7.5 8.3"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#3070b3",
				strokeLinecap: "butt",
				strokeLinejoin: "miter",
				strokeWidth: 1,
			}}
		/>
		<path
			d="M602.4 282.4v.4l-1.6 3a1 1 0 0 0 1.7 1.1l.3-.3c.5.4 1.1 1.4-.2 4a.9.9 0 0 0 1.4 1 .9.9 0 0 0 1.6.6v-.1l.4.3a.9.9 0 0 0 1.2-.4v-.1a.9.9 0 0 0 1.3-.4c.4-.7.6-1.4.8-2l.2-1a14 14 0 0 0-.3-6.2v-.8a58.4 58.4 0 0 0-10.4-26.3l-5.5 4.1a51.7 51.7 0 0 1 9 23"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M595 250.5a3.4 3.4 0 0 0-5 4.8 26 26 0 0 1 3.3 4l5.5-4c-2-3-3.7-4.6-3.8-4.8"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m593.3 259.3-3.2-4"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#9abce4",
				strokeWidth: ".24px",
			}}
		/>
		<path
			d="m336.5 165.7-7.4 14h-19.5V178h19.1l6.8-13 1 .7Z"
			style={{
				fill: "#114584",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M309.3 150.5c0 2.4-.5 4.4-2.5 4.5-2 0-4.6-.8-4.8-4.2-.1-2.4 1.4-4.3 3.5-4.4 2-.1 3.7 1.7 3.8 4"
			style={{
				fill: "#5e94d4",
			}}
		/>
		<path
			d="M305.4 156.9s-1.3 0-2.7-.5c-1.7-.7-1.9-1.2-1.9-1.2l2.6-4.4 3.5 2.1-1.5 4Zm3.5-6.5s.8 1.5.7 1.8c0 .3-.8.3-.8.3"
			style={{
				fill: "#5e94d4",
			}}
		/>
		<path
			d="M304.1 150.7c.4.6 1.2 1 1.6 0 .3-1.1.2-1.4.7-1.6.7-.1.5.4 2.9.5 1.4.1 2-1 1.8-1.7 0-.4-.3-1.1-1.2-1.3l-1.6-.2c-.8-.2-1.1-1-2.4-1-1.3 0-2 1-2 1s-1-.5-1.9.6c-.7 1.1-.3 1.6-.7 2.6-.5 1-.2 2.6.3 3 1.3 1.3 2.5.1 2.5.1s-1.3-2.1-.3-2"
			style={{
				fill: "#212237",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M304.6 150.8s-.3-.7-1-.3c-.8.4-.2 1.9.4 2.2.5.3.8-.3.8-.3"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M320 226.5v.5l11.9 1.5v-.6l-11.9-1.4Z"
			style={{
				fill: "#3c71a5",
			}}
		/>
		<path
			d="m322.2 222.3-1 .1s-.6 1.3-.8 2.3l-.4 1.8 12 1.4s-.2-1-2.9-3c-1-.8-1.5-1.6-1.5-1.6l-5.4-1Z"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m319.6 214.2 1.6 8.2s.4.7 2.4 1c2 .2 4-.1 4-.1l-1-10.5"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m328.3 193 1.8 27.7-10.8 1.4-2.2-24.5"
			style={{
				fill: "#09233d",
				fillRule: "nonzero",
			}}
		/>
		<g opacity={0.3}>
			<clipPath id="d">
				<path clipRule="nonzero" d="M319 220.2h11v-1.7h-11v1.7Z" />
			</clipPath>
			<g clipPath="url(#d)">
				<path
					d="m319 220 11-1.4"
					style={{
						fill: "none",
						fillRule: "nonzero",
						stroke: "#5e94d4",
						strokeLinecap: "butt",
						strokeLinejoin: "miter",
						strokeWidth: ".3px",
					}}
				/>
			</g>
		</g>
		<path
			d="m308.3 219.8-.2.5 10.9 5 .2-.4-10.9-5Z"
			style={{
				fill: "#3c71a5",
			}}
		/>
		<path
			d="m311.7 216.5-1-.2s-1 1-1.5 1.9l-.9 1.7 11 5s0-1-1.8-3.8c-.8-1-1-2-1-2l-4.8-2.6Z"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="m312.3 213.4-1.6 3s.2.7 2 1.5c1.9.9 3.8 1.2 3.8 1.2l3.3-5"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M292.3 180.2s-3.4 18 5.4 18h17.9a1 1 0 0 1 1 1.4l-5 14.7 10.6 4.6s8.6-19.5 7.7-26.8c-1-7.3-25.3-8.2-25.3-8.2L302 179"
			style={{
				fill: "#0a2d57",
				fillRule: "nonzero",
			}}
		/>
		<g opacity={0.4}>
			<clipPath id="e">
				<path clipRule="nonzero" d="M296.2 182.4H323v35h-26.8z" />
			</clipPath>
			<g clipPath="url(#e)">
				<path
					d="M296.7 182.4s-1.8 9.8 2.7 11.3c4.6 1.5 14.5.4 17.7 1 2.5.6 4.3 1.5 2.3 6.5l-5.5 14.2"
					style={{
						fill: "none",
						fillRule: "nonzero",
						stroke: "#497bb7",
						strokeLinecap: "butt",
						strokeLinejoin: "miter",
						strokeWidth: ".3px",
					}}
				/>
				<path
					d="M303.4 183.7c-.4 3.2-7 4.4-7 4.4m15.7 24.4 10.8 4.8"
					style={{
						fill: "none",
						fillRule: "nonzero",
						stroke: "#497bb7",
						strokeLinecap: "butt",
						strokeLinejoin: "miter",
						strokeWidth: ".3px",
					}}
				/>
			</g>
		</g>
		<path
			d="M322.5 178.9c.8 0 4.5-.3 4.6 0 0 .2-1.3.4-1.2.5 0 .2 1 .2 1.6.1.5 0 1.2 0 1.3.2 0 .4-2.6.6-2.6.6s2.8-.8 3-.4c0 .4-2.9 1.1-3 1.3 0 0 2.4-1.4 2.6-1 0 .3-2 1.5-2.8 1.7.6-.2 2.3-1.4 2.4-1.2 0 .3-1.5 1.1-1.7 1.2-2 .7-4 .7-4 .7"
			style={{
				fill: "#5e94d4",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M306.1 163.2c0 8 1.2 10.8 4 12.5 2.8 1.7 9.2 2.2 13 2.6l-.4 6s-14.8-.3-18.6-2.3c-3.8-2-4.4-13.5-4.4-13.5"
			style={{
				fill: "#0065bd",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M305.5 156.7c3.8 3.8 5.3 27.7 5.3 27.7-9.1.5-22 .6-22 .6s1.2-17.5 4.6-23c3-4.8 7.5-7 7.5-7s.8 1.1 2.2 1.5c1.4.3 2.4.2 2.4.2"
			style={{
				fill: "#0065bd",
				fillRule: "nonzero",
			}}
		/>
		<path
			d="M310.7 176c-4.4-1.7-4.3-11-4.3-11m4.4 18.5s-6.5 0-9.4-5.5c-3-5.5-3.5-11.7-3.5-11.7"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#0d5099",
				strokeWidth: ".18px",
			}}
		/>
		<path
			d="M2.1 338.4h591.2m11.7 0h24.2"
			style={{
				fill: "none",
				fillRule: "nonzero",
				stroke: "#0065bd",
				strokeWidth: 3,
			}}
		/>
	</svg>
);
